
import { Link } from "react-router-dom";
// import React, { useEffect, useState } from 'react';
// import $ from 'jquery';
// import 'datatables.net';





const Jobs = () => {


  return (
    <>
      {/* <!-- Header Start --> */}
      <div className="container-fluid bg-primary py-5 mb-5 page-header">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h1 className="display-3 text-white animated slideInDown">Jobs</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item"><Link className="text-white" to="#">Home</Link></li>
                  <li className="breadcrumb-item"><Link className="text-white" to="#">Pages</Link></li>
                  <li className="breadcrumb-item text-white active" aria-current="page">Jobs</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Header End --> */}

      {/* <!-- Service Start --> */}
      <div className="container-xxl py-5">
        <div className="container">
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">Jobs Listing</h3>
                    </div>
                    {/* <!-- /.card-header --> */}
                    <div className="card-body">
                      <table id="jobs" className="table table-bordered table-striped jobs">
                        <thead>
                          <tr className="text-center">
                            <th className="text-center">S.No</th>
                            <th>Job Title</th>
                            <th>Company Name</th>
                            <th>Location</th>
                            <th>Designation</th>
                            <th>Last Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-center">1</td>
                            <td>Vacancy For Telecaller</td>
                            <td>Kamlin Pvt Ltd</td>
                            <td>Gurugram</td>
                            <td>Tellecaller</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='1'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">2</td>
                            <td>Vacancy For Telecaller</td>
                            <td>Kamlin Pvt Ltd</td>
                            <td>Gurugram</td>
                            <td>Tellecaller</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='2'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">3</td>
                            <td>Vacancy For  Junior HR</td>
                            <td>HRX Company</td>
                            <td>Noida</td>
                            <td>Jr. HR</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='5'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">4</td>
                            <td>Full Stack Developer</td>
                            <td>HCL</td>
                            <td>Noida UP</td>
                            <td>Full Stack Developer</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='6'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">5</td>
                            <td>SEO Manager</td>
                            <td>TCS</td>
                            <td>Gurugram</td>
                            <td>SEO Manager</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='7'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">6</td>
                            <td>Vacancy For Telecaller</td>
                            <td>Kamlin Pvt Ltd</td>
                            <td>Gurugram</td>
                            <td>Tellecaller</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='8'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">7</td>
                            <td>Vacancy For Telecaller</td>
                            <td>Kamlin Pvt Ltd</td>
                            <td>Gurugram</td>
                            <td>Tellecaller</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='9'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">8</td>
                            <td>Vacancy For  Junior HR</td>
                            <td>HRX Company</td>
                            <td>Noida</td>
                            <td>Jr. HR</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='10'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">9</td>
                            <td>Full Stack Developer</td>
                            <td>HCL</td>
                            <td>Noida UP</td>
                            <td>Full Stack Developer</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='11'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">10</td>
                            <td>SEO Manager</td>
                            <td>TCS</td>
                            <td>Gurugram</td>
                            <td>SEO Manager</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='12'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">11</td>
                            <td>Vacancy For Telecaller</td>
                            <td>Kamlin Pvt Ltd</td>
                            <td>Gurugram</td>
                            <td>Tellecaller</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='13'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">12</td>
                            <td>Vacancy For Telecaller</td>
                            <td>Kamlin Pvt Ltd</td>
                            <td>Gurugram</td>
                            <td>Tellecaller</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='14'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">13</td>
                            <td>Vacancy For  Junior HR</td>
                            <td>HRX Company</td>
                            <td>Noida</td>
                            <td>Jr. HR</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='15'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">14</td>
                            <td>Full Stack Developer</td>
                            <td>HCL</td>
                            <td>Noida UP</td>
                            <td>Full Stack Developer</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='16'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">15</td>
                            <td>SEO Manager</td>
                            <td>TCS</td>
                            <td>Gurugram</td>
                            <td>SEO Manager</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='17'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">16</td>
                            <td>Vacancy For Telecaller</td>
                            <td>Kamlin Pvt Ltd</td>
                            <td>Gurugram</td>
                            <td>Tellecaller</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='18'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">17</td>
                            <td>Vacancy For Telecaller</td>
                            <td>Kamlin Pvt Ltd</td>
                            <td>Gurugram</td>
                            <td>Tellecaller</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='19'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">18</td>
                            <td>Vacancy For  Junior HR</td>
                            <td>HRX Company</td>
                            <td>Noida</td>
                            <td>Jr. HR</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='20'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">19</td>
                            <td>Full Stack Developer</td>
                            <td>HCL</td>
                            <td>Noida UP</td>
                            <td>Full Stack Developer</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='21'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                          <tr>
                            <td className="text-center">20</td>
                            <td>SEO Manager</td>
                            <td>TCS</td>
                            <td>Gurugram</td>
                            <td>SEO Manager</td>
                            <td>2025-09-30</td>
                            <td className="text-center"> <button className='btn btn-success btn-sm view_job' data-id='22'><i className='fa fa-info'> View</i> </button></td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

      </div>


    </>

  );
};

export default Jobs;
